import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './modules/auth/_services/auth.guard';
import {FinishProcessComponent} from './pages/post-auth/finish-process/finish-process.component';
import {DownloadComponent} from './pages/post-auth/download/download.component';
import {ShareComponent} from './pages/post-auth/share/share.component';
import {PostInviteComponent} from './pages/post-auth/post-invite/post-invite.component';
import {ReviewComponent} from './pages/post-auth/review/review.component';
import {CompletionGuard} from './modules/auth/_services/completion.guard';
import { PlanComponent } from './pages/post-auth/plan/plan.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },


  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },

    {
        path: 'finish',
        canActivate: [AuthGuard],
        component:FinishProcessComponent
    },
    // {
    //     path: 'plan',
    //     canActivate: [AuthGuard],
    //     component:PlanComponent
    // },

    {
        path: 'download',
        canActivate: [AuthGuard, CompletionGuard],

        component:DownloadComponent
    },


    {
        path: 'share',
        canActivate: [AuthGuard, /* CompletionGuard */],

        component:ShareComponent
    },

    {
        path: 'thanks',
        canActivate: [AuthGuard, /* CompletionGuard */],

        component:PostInviteComponent

    },

    {
        path: 'review',
        canActivate: [AuthGuard, CompletionGuard],

        component:ReviewComponent
    },

    {
        path: '',

        loadChildren: () =>
            import('./pages/layout.module').then((m) => m.LayoutModule),
    },




    { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
